export default function NoMatchRouter() {
  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <div className="text-3xl">404 - page non found</div>
    </div>
  );
}
